import { render, staticRenderFns } from "./ModalConfirmacaoCancelamentoFatura.vue?vue&type=template&id=73735848"
import script from "./ModalConfirmacaoCancelamentoFatura.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacaoCancelamentoFatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports